exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__aspect-r___2Wp2T{display:inline-block;position:relative;width:100%;height:100%;aspect-ratio:16/9}.index-module__aspect-r___2Wp2T.index-module__homepage___2QzOI{aspect-ratio:unset}.index-module__aspect-r___2Wp2T.index-module__homepage___2QzOI iframe{border-radius:26px}.index-module__aspect-r___2Wp2T iframe{position:absolute;width:100%;height:100%;left:0;top:0;border-radius:18px}", ""]);

// exports
exports.locals = {
	"aspect-r": "index-module__aspect-r___2Wp2T",
	"homepage": "index-module__homepage___2QzOI"
};